import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuthentication } from "../features/Authentication/context";
import { clearPostLoginPath, peekPostLoginPath } from "./postLoginPath";

// Goes once to the page the user was on before logging in, else home.
function PostLoginNavigate() {
	const [path] = useState(peekPostLoginPath);

	useEffect(() => {
		clearPostLoginPath();
	}, []);

	return <Navigate to={path || "/"} />;
}

function Redirect() {
	const { token, authenticated, company, isMainDomain, user } =
		useAuthentication();

	const impersonate = localStorage.getItem("IMPERSONATE");
	const otpValidate = localStorage.getItem("OTP_VALIDATE");

	if (!token) {
		if (isMainDomain) {
			return <Navigate to="/domain-select" replace />;
		}
		return <Navigate to="/login" replace />;
	}

	if (
		user?.twoFA?.status === "active" &&
		!impersonate &&
		otpValidate === null
	) {
		return <Navigate to="/login/validate" replace />;
	}

	if (
		authenticated && !company &&
		((user?.twoFA?.status !== "active" &&
			(user?.twoFA?.type ||
				user?.twoFA?.type === null ||
				!user?.twoFA?.type)) ||
			otpValidate !== null)
	) {
		return <Navigate to="/company-selection" replace />;
	}

	if (user?.requirePasswordChange) {
		return <Navigate to="/required-set-password" replace />;
	}

	return <PostLoginNavigate />;
}

export default Redirect;
